// AUTO-GENERATED by scripts/generate-guide-map.mjs — do not edit by hand.
// Purpose-built so product and category pages can link into the journal
// without importing the full journal metadata module.

export interface GuideLink {
  slug: string;
  title: string;
}

export const GUIDES_BY_CATEGORY: Record<string, GuideLink[]> = {
  "living": [
    {
      "slug": "how-to-choose-a-coffee-table",
      "title": "How to Choose a Coffee Table: Size, Shape, and Height"
    },
    {
      "slug": "modern-loft-look",
      "title": "The Modern Loft Look: Industrial Bones, Warm Layers"
    },
    {
      "slug": "how-to-choose-an-accent-chair",
      "title": "How to Choose an Accent Chair: Comfort, Scale, and Style"
    }
  ],
  "bed-bath": [
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    },
    {
      "slug": "how-to-choose-a-dresser",
      "title": "How to Choose a Dresser or Chest of Drawers: Sizing, Types, and Fit"
    },
    {
      "slug": "mirror-size-guide",
      "title": "Mirror Size Guide: How Big & How High to Hang"
    }
  ],
  "bedroom": [
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    },
    {
      "slug": "platform-bed-vs-box-spring",
      "title": "Platform Bed vs. Box Spring: What Modern Bedrooms Actually Need"
    },
    {
      "slug": "nightstand-height-guide",
      "title": "Nightstand Guide: Height, Width, and How to Pair Them"
    }
  ],
  "beds": [
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    },
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    },
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "mattresses": [
    {
      "slug": "mattress-buying-guide",
      "title": "Mattress Buying Guide: How to Choose the Right Mattress Online"
    },
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    },
    {
      "slug": "memory-foam-vs-hybrid-vs-innerspring-mattresses",
      "title": "Memory Foam vs. Hybrid vs. Innerspring Mattresses Compared"
    }
  ],
  "dining": [
    {
      "slug": "dining-table-size-guide",
      "title": "Dining Table Size Guide: How Many Seats, How Much Clearance, What Fits"
    },
    {
      "slug": "round-vs-rectangular-dining-table",
      "title": "Round vs. Rectangular Dining Table: How to Decide"
    },
    {
      "slug": "dining-room-mistakes",
      "title": "Dining Room Mistakes That Make Dinners Feel Cramped (and How to Fix Them)"
    }
  ],
  "office": [
    {
      "slug": "how-to-choose-a-desk",
      "title": "How to Choose a Desk for a Home Office: Size, Depth, and Type"
    },
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    },
    {
      "slug": "how-to-choose-an-office-chair",
      "title": "How to Choose an Office Chair You Can Actually Sit In All Day"
    }
  ],
  "outdoor": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "lighting": [
    {
      "slug": "chandelier-size-guide",
      "title": "Chandelier and Ceiling Light Size Guide: Getting Scale Right"
    },
    {
      "slug": "lighting-mistakes",
      "title": "6 Lighting Mistakes That Flatten Your Room (and the Easy Fixes)"
    },
    {
      "slug": "pendant-light-height",
      "title": "Pendant Lighting Height Over a Kitchen Island (Exact Numbers)"
    }
  ],
  "decor": [
    {
      "slug": "make-rental-feel-like-home",
      "title": "The Renter's Guide to a Home That Feels Permanent"
    },
    {
      "slug": "curtain-size-guide",
      "title": "Curtain and Drapery Size Guide: Length, Width, and Hanging Height"
    },
    {
      "slug": "how-to-plan-and-hang-a-gallery-wall",
      "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)"
    }
  ],
  "area-rugs": [
    {
      "slug": "rug-size-guide",
      "title": "What Size Rug Do You Need? The Complete Rug Size Guide for Every Room"
    },
    {
      "slug": "wool-rug-guide",
      "title": "Wool Rugs: Why They Cost More, How Long They Last, and How to Clean One"
    },
    {
      "slug": "jute-vs-sisal-vs-seagrass-rugs",
      "title": "Jute vs Sisal vs Seagrass Rugs: Softness, Durability, and Where Each Belongs"
    }
  ],
  "bathroom": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    },
    {
      "slug": "bathroom-vanity-size-guide",
      "title": "What Size Bathroom Vanity? Width, Height, Depth and Clearances"
    },
    {
      "slug": "teak-shower-bench-guide",
      "title": "Teak Shower Bench: Why Teak, How to Choose, and How to Care for It"
    }
  ],
  "sofas": [
    {
      "slug": "sofa-dimensions-guide",
      "title": "Sofa Dimensions 101: How to Measure Your Space Before You Buy"
    },
    {
      "slug": "velvet-fabric-guide",
      "title": "Velvet Fabric Guide: Types, Durability, and How to Clean a Velvet Sofa"
    },
    {
      "slug": "faux-leather-vs-real-leather",
      "title": "Faux Leather vs Real Leather: PU, Vegan, and Bonded Leather Explained"
    }
  ],
  "love-seats": [
    {
      "slug": "sofa-bed-vs-daybed-vs-futon",
      "title": "Sofa Bed vs. Daybed vs. Futon: Guest-Sleeping Options Compared"
    },
    {
      "slug": "sofa-buying-mistakes",
      "title": "7 Sofa-Buying Mistakes Designers See All the Time (and How to Avoid Every One)"
    },
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    }
  ],
  "sectionals": [
    {
      "slug": "modular-vs-fixed-sectional",
      "title": "Modular vs. Fixed Sectionals: Flexibility or Stability?"
    },
    {
      "slug": "faux-leather-vs-real-leather",
      "title": "Faux Leather vs Real Leather: PU, Vegan, and Bonded Leather Explained"
    },
    {
      "slug": "best-sectionals-for-small-spaces",
      "title": "The Best Sectionals for Small Spaces: Our Picks"
    }
  ],
  "seating-sets": [
    {
      "slug": "sofa-dimensions-guide",
      "title": "Sofa Dimensions 101: How to Measure Your Space Before You Buy"
    },
    {
      "slug": "sofa-buying-mistakes",
      "title": "7 Sofa-Buying Mistakes Designers See All the Time (and How to Avoid Every One)"
    }
  ],
  "accent-chairs": [
    {
      "slug": "how-to-choose-an-accent-chair",
      "title": "How to Choose an Accent Chair: Comfort, Scale, and Style"
    },
    {
      "slug": "what-is-boucle-fabric",
      "title": "What Is Boucle Fabric? Materials, Durability, and Care Explained"
    },
    {
      "slug": "velvet-fabric-guide",
      "title": "Velvet Fabric Guide: Types, Durability, and How to Clean a Velvet Sofa"
    }
  ],
  "recliners": [
    {
      "slug": "best-accent-chairs-for-reading",
      "title": "The Best Accent Chairs for Reading: A Buyer's Guide (2026)"
    },
    {
      "slug": "faux-leather-vs-real-leather",
      "title": "Faux Leather vs Real Leather: PU, Vegan, and Bonded Leather Explained"
    }
  ],
  "ottomans": [
    {
      "slug": "how-to-choose-an-ottoman",
      "title": "Ottoman Guide: Storage, Cocktail, and Accent Ottomans Compared"
    },
    {
      "slug": "what-is-boucle-fabric",
      "title": "What Is Boucle Fabric? Materials, Durability, and Care Explained"
    }
  ],
  "rocking-chairs": [
    {
      "slug": "best-accent-chairs-for-reading",
      "title": "The Best Accent Chairs for Reading: A Buyer's Guide (2026)"
    },
    {
      "slug": "nursery-furniture-guide",
      "title": "Nursery Furniture Guide: Crib, Glider, Dresser, and Storage"
    }
  ],
  "bean-bags": [
    {
      "slug": "how-to-create-a-reading-nook",
      "title": "How to Create a Reading Nook (in Any Room, Any Size)"
    },
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    }
  ],
  "coffee-tables": [
    {
      "slug": "how-to-choose-a-coffee-table",
      "title": "How to Choose a Coffee Table: Size, Shape, and Height"
    },
    {
      "slug": "tempered-glass-table-guide",
      "title": "Tempered Glass Tables: Are Glass Table Tops Safe, and How to Choose One"
    },
    {
      "slug": "what-is-mango-wood",
      "title": "What Is Mango Wood? Hardness, Color, and Furniture Care Explained"
    }
  ],
  "end-tables": [
    {
      "slug": "end-table-height-guide",
      "title": "End Table Height Guide: Sizing Beside a Sofa"
    },
    {
      "slug": "how-to-choose-a-coffee-table",
      "title": "How to Choose a Coffee Table: Size, Shape, and Height"
    }
  ],
  "console-tables": [
    {
      "slug": "console-table-guide",
      "title": "Console Table Guide: Placement, Sizing, and Uses"
    },
    {
      "slug": "tempered-glass-table-guide",
      "title": "Tempered Glass Tables: Are Glass Table Tops Safe, and How to Choose One"
    },
    {
      "slug": "what-is-mango-wood",
      "title": "What Is Mango Wood? Hardness, Color, and Furniture Care Explained"
    }
  ],
  "tv-stands": [
    {
      "slug": "how-to-choose-a-tv-stand",
      "title": "How to Choose a Media Console (TV Stand): Size, Height, and Cables"
    },
    {
      "slug": "mdf-vs-particle-board",
      "title": "MDF vs Particle Board vs Plywood: What MDF Wood Is and Which to Choose"
    },
    {
      "slug": "tv-size-for-room",
      "title": "What Size TV for Your Room? Viewing Distance Explained"
    }
  ],
  "bookcases": [
    {
      "slug": "how-to-choose-a-bookcase",
      "title": "How to Choose a Bookcase or Open Shelving: Depth, Height, and Type"
    },
    {
      "slug": "how-to-style-a-bookshelf",
      "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)"
    },
    {
      "slug": "best-bookcases-for-small-spaces",
      "title": "The Best Bookcases for Small Spaces (2026 Buyer's Guide)"
    }
  ],
  "wall-mounted-shelves": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    },
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "cabinets": [
    {
      "slug": "best-storage-furniture-small-apartments",
      "title": "The Best Storage Furniture for Small Apartments: Our Picks"
    }
  ],
  "sideboards": [
    {
      "slug": "how-to-style-a-sideboard",
      "title": "How to Style a Sideboard or Buffet: A Simple, Layered Formula"
    },
    {
      "slug": "what-is-mango-wood",
      "title": "What Is Mango Wood? Hardness, Color, and Furniture Care Explained"
    }
  ],
  "room-dividers": [
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    },
    {
      "slug": "zone-open-plan-living-room",
      "title": "Open-Plan Living: How to Zone One Big Room"
    }
  ],
  "coat-racks": [
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    }
  ],
  "pet-beds": [
    {
      "slug": "pet-friendly-furniture",
      "title": "Pet-Friendly Furniture and Fabrics: What Holds Up to Cats and Dogs"
    }
  ],
  "rug-pads": [
    {
      "slug": "rug-care-101",
      "title": "Rug Care 101: Keeping Handwoven Rugs Looking New"
    },
    {
      "slug": "rug-size-guide",
      "title": "What Size Rug Do You Need? The Complete Rug Size Guide for Every Room"
    }
  ],
  "standard-beds": [
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    },
    {
      "slug": "upholstered-vs-wood-vs-metal-bed-frames",
      "title": "Upholstered vs. Wood vs. Metal Bed Frames: Material Comparison"
    },
    {
      "slug": "platform-bed-vs-box-spring",
      "title": "Platform Bed vs. Box Spring: What Modern Bedrooms Actually Need"
    }
  ],
  "bunk-beds": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    },
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    }
  ],
  "loft-beds": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    },
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    }
  ],
  "bed-sheets": [
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "bed-pillows": [
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "dressers": [
    {
      "slug": "how-to-choose-a-dresser",
      "title": "How to Choose a Dresser or Chest of Drawers: Sizing, Types, and Fit"
    },
    {
      "slug": "mdf-vs-particle-board",
      "title": "MDF vs Particle Board vs Plywood: What MDF Wood Is and Which to Choose"
    }
  ],
  "headboards": [
    {
      "slug": "headboard-guide",
      "title": "Headboard Guide: Styles, Heights, and Sizing by Bed Size"
    }
  ],
  "benches": [
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    },
    {
      "slug": "dining-room-mistakes",
      "title": "Dining Room Mistakes That Make Dinners Feel Cramped (and How to Fix Them)"
    },
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    }
  ],
  "kids-chairs": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    }
  ],
  "curtains-drapes": [
    {
      "slug": "curtain-size-guide",
      "title": "Curtain and Drapery Size Guide: Length, Width, and Hanging Height"
    },
    {
      "slug": "blackout-curtains-guide",
      "title": "Blackout Curtains: How They Work, Blackout vs Room Darkening, and How to Hang Them"
    },
    {
      "slug": "how-to-choose-curtains-for-modern-rooms",
      "title": "How to Choose Curtains for Modern Rooms: Fabric, Color, and Fit"
    }
  ],
  "foam-hybrid-mattresses": [
    {
      "slug": "mattress-buying-guide",
      "title": "Mattress Buying Guide: How to Choose the Right Mattress Online"
    },
    {
      "slug": "memory-foam-vs-hybrid-vs-innerspring-mattresses",
      "title": "Memory Foam vs. Hybrid vs. Innerspring Mattresses Compared"
    },
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    }
  ],
  "air-mattress": [
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    }
  ],
  "mattress-toppers": [
    {
      "slug": "mattress-buying-guide",
      "title": "Mattress Buying Guide: How to Choose the Right Mattress Online"
    },
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    }
  ],
  "bathroom-vanities": [
    {
      "slug": "bathroom-vanity-size-guide",
      "title": "What Size Bathroom Vanity? Width, Height, Depth and Clearances"
    },
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    }
  ],
  "bathroom-storage": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    }
  ],
  "bath-towels": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    }
  ],
  "dining-tables": [
    {
      "slug": "dining-table-size-guide",
      "title": "Dining Table Size Guide: How Many Seats, How Much Clearance, What Fits"
    },
    {
      "slug": "what-is-sintered-stone",
      "title": "What Is Sintered Stone? Table Tops, Durability, and Sintered Stone vs Quartz"
    },
    {
      "slug": "what-is-rubberwood",
      "title": "What Is Rubberwood? Parawood Furniture, Hardness, and Care Explained"
    }
  ],
  "tabletop": [
    {
      "slug": "how-to-set-a-table",
      "title": "How to Set a Table: Everyday to Dinner Party, Step by Step"
    },
    {
      "slug": "home-bar-cart-styling",
      "title": "The Home Bar Cart: How to Set Up and Style One That Works"
    },
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    }
  ],
  "dining-chairs": [
    {
      "slug": "how-to-choose-dining-chairs",
      "title": "How to Choose Dining Chairs: Comfort, Height, and Material"
    },
    {
      "slug": "powder-coated-steel-furniture",
      "title": "Powder-Coated Steel Furniture: Does It Rust, and How to Care for It"
    }
  ],
  "dining-sets": [
    {
      "slug": "dining-table-size-guide",
      "title": "Dining Table Size Guide: How Many Seats, How Much Clearance, What Fits"
    },
    {
      "slug": "breakfast-nook-ideas",
      "title": "How to Design a Breakfast Nook: Seating, Size, and Layout"
    }
  ],
  "bar-chairs": [
    {
      "slug": "bar-counter-stool-height-guide",
      "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure"
    }
  ],
  "pantry-cabinets": [
    {
      "slug": "best-storage-furniture-small-apartments",
      "title": "The Best Storage Furniture for Small Apartments: Our Picks"
    }
  ],
  "kitchen-islands": [
    {
      "slug": "bar-counter-stool-height-guide",
      "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure"
    },
    {
      "slug": "pendant-light-height",
      "title": "Pendant Lighting Height Over a Kitchen Island (Exact Numbers)"
    }
  ],
  "desks": [
    {
      "slug": "how-to-choose-a-desk",
      "title": "How to Choose a Desk for a Home Office: Size, Depth, and Type"
    },
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    },
    {
      "slug": "first-apartment-furniture-checklist",
      "title": "Furnishing Your First Apartment: The Complete Checklist (and What to Skip)"
    }
  ],
  "office-chairs": [
    {
      "slug": "how-to-choose-an-office-chair",
      "title": "How to Choose an Office Chair You Can Actually Sit In All Day"
    },
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    }
  ],
  "filing-cabinets": [
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    }
  ],
  "shoe-racks": [
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    },
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    }
  ],
  "patio-sets": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    },
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    }
  ],
  "outdoor-sofas": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "rattan-vs-wicker",
      "title": "Rattan vs Wicker: What's the Difference (and Where Cane Fits In)"
    },
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "outdoor-chairs": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "powder-coated-steel-furniture",
      "title": "Powder-Coated Steel Furniture: Does It Rust, and How to Care for It"
    },
    {
      "slug": "rattan-vs-wicker",
      "title": "Rattan vs Wicker: What's the Difference (and Where Cane Fits In)"
    }
  ],
  "outdoor-tables": [
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "acacia-wood-furniture",
      "title": "Acacia Wood Furniture: Hardness, Outdoor Use, and Care Explained"
    },
    {
      "slug": "powder-coated-steel-furniture",
      "title": "Powder-Coated Steel Furniture: Does It Rust, and How to Care for It"
    }
  ],
  "outdoor-ottomans": [
    {
      "slug": "how-to-choose-an-ottoman",
      "title": "Ottoman Guide: Storage, Cocktail, and Accent Ottomans Compared"
    },
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    }
  ],
  "outdoor-umbrellas": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "outdoor-rugs": [
    {
      "slug": "are-washable-rugs-worth-it",
      "title": "Are Washable Rugs Worth It? What They're Good At, Sizes, and How to Wash Them"
    },
    {
      "slug": "outdoor-rug-size-guide",
      "title": "Outdoor Rug Size Guide: Patio & Deck Sizing"
    },
    {
      "slug": "rug-size-guide",
      "title": "What Size Rug Do You Need? The Complete Rug Size Guide for Every Room"
    }
  ],
  "outdoor-fireplaces": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "outdoor-accessories": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "outdoor-planters": [
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    },
    {
      "slug": "biophilic-design",
      "title": "Biophilic Design: Bringing Nature Indoors"
    }
  ],
  "chandeliers": [
    {
      "slug": "chandelier-size-guide",
      "title": "Chandelier and Ceiling Light Size Guide: Getting Scale Right"
    },
    {
      "slug": "how-to-clean-a-chandelier",
      "title": "How to Clean a Chandelier (Including Crystal Chandeliers)"
    },
    {
      "slug": "brass-vs-bronze",
      "title": "Brass vs Bronze: What Each Is Made Of, How to Tell Them Apart, and How to Care for Them"
    }
  ],
  "floor-lamps": [
    {
      "slug": "floor-lamp-buying-guide",
      "title": "Floor Lamp Buying Guide: Height, Light, and Placement"
    },
    {
      "slug": "lumens-vs-watts",
      "title": "Lumens vs Watts: Lumens-to-Watts Chart and How Many Lumens You Need per Room"
    },
    {
      "slug": "layered-lighting-101",
      "title": "Layered Lighting 101: Ambient, Task, and Accent — Explained Simply"
    }
  ],
  "table-lamps": [
    {
      "slug": "table-lamp-size-guide",
      "title": "Table Lamp Size Guide: How Tall & How Wide"
    },
    {
      "slug": "lumens-vs-watts",
      "title": "Lumens vs Watts: Lumens-to-Watts Chart and How Many Lumens You Need per Room"
    },
    {
      "slug": "brass-vs-bronze",
      "title": "Brass vs Bronze: What Each Is Made Of, How to Tell Them Apart, and How to Care for Them"
    }
  ],
  "mirrors": [
    {
      "slug": "mirror-size-guide",
      "title": "Mirror Size Guide: How Big & How High to Hang"
    },
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "sculptures": [
    {
      "slug": "how-to-decorate-with-sculptures",
      "title": "How to Decorate with Sculptures: Size, Placement, and Grouping"
    },
    {
      "slug": "what-is-polyresin",
      "title": "What Is Polyresin? Polyresin vs Polystone vs Ceramic for Sculptures and Decor"
    },
    {
      "slug": "how-to-style-a-bookshelf",
      "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)"
    }
  ],
  "vases": [
    {
      "slug": "vase-size-guide",
      "title": "Vase Size Guide: Height, Shape & Placement"
    },
    {
      "slug": "ceramic-vs-porcelain",
      "title": "Ceramic vs Porcelain: What's the Difference for Vases, Tiles, and Tableware?"
    },
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    }
  ],
  "throw-pillows": [
    {
      "slug": "throw-pillow-size-guide",
      "title": "Throw Pillow Sizes and Arrangement Guide"
    },
    {
      "slug": "how-to-mix-throw-pillows",
      "title": "How to Mix Throw Pillows Like a Designer (Without Overthinking It)"
    },
    {
      "slug": "add-warmth-with-textiles",
      "title": "How to Make a Room Cozy with Textiles: Layering Soft Goods"
    }
  ],
  "planters": [
    {
      "slug": "biophilic-design",
      "title": "Biophilic Design: Bringing Nature Indoors"
    },
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "candle-holders": [
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    }
  ],
  "picture-frames": [
    {
      "slug": "how-to-hang-a-picture",
      "title": "How to Hang a Picture: Height, Hardware, and Hanging Frames Without Nails"
    },
    {
      "slug": "picture-frame-sizes",
      "title": "Standard Picture Frame Sizes: A Complete Guide (in Inches)"
    },
    {
      "slug": "how-to-plan-and-hang-a-gallery-wall",
      "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)"
    }
  ],
  "trays": [
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "home-bar-cart-styling",
      "title": "The Home Bar Cart: How to Set Up and Style One That Works"
    }
  ],
  "wall-clocks": [
    {
      "slug": "wall-clock-size-guide",
      "title": "What Size Wall Clock? Size and Hanging Height by Room"
    },
    {
      "slug": "wall-art-size-guide",
      "title": "Wall Art Size Guide: Over a Sofa, Bed & More"
    }
  ],
  "baskets-organizers": [
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    },
    {
      "slug": "how-to-style-a-bookshelf",
      "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)"
    }
  ],
  "wall-decor": [
    {
      "slug": "wall-art-size-guide",
      "title": "Wall Art Size Guide: Over a Sofa, Bed & More"
    },
    {
      "slug": "how-to-plan-and-hang-a-gallery-wall",
      "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)"
    },
    {
      "slug": "living-room-feels-unfinished",
      "title": "Why Your Living Room Feels Unfinished — and the 5 Fixes That Work"
    }
  ],
  "nightstands": [
    {
      "slug": "nightstand-height-guide",
      "title": "Nightstand Guide: Height, Width, and How to Pair Them"
    },
    {
      "slug": "mdf-vs-particle-board",
      "title": "MDF vs Particle Board vs Plywood: What MDF Wood Is and Which to Choose"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "bedroom-sets": [
    {
      "slug": "how-to-arrange-bedroom-furniture",
      "title": "How to Arrange Bedroom Furniture: Layouts That Actually Work"
    },
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "comforters-duvets": [
    {
      "slug": "duvet-vs-comforter",
      "title": "Duvet vs Comforter: What's the Difference and Which Should You Buy?"
    },
    {
      "slug": "linen-vs-cotton-sheets",
      "title": "Linen vs Cotton Sheets: Feel, Breathability, Wrinkles, and Which to Buy"
    },
    {
      "slug": "what-is-oeko-tex-certified",
      "title": "What Is OEKO-TEX Certified? Standard 100 Explained for Bedding, Throws, and Rugs"
    }
  ],
  "throws-blankets": [
    {
      "slug": "throw-blanket-size-guide",
      "title": "Throw Blanket Size Guide: Sofa, Bed & Chair"
    },
    {
      "slug": "how-to-wash-blankets",
      "title": "How to Wash Blankets: Wool, Fleece, Knit, and Throws Without Ruining Them"
    },
    {
      "slug": "what-is-a-sherpa-blanket",
      "title": "What Is a Sherpa Blanket? Sherpa vs Fleece, How to Wash It, and How to Make It Soft Again"
    }
  ],
  "doormats": [
    {
      "slug": "doormat-size-guide",
      "title": "Standard Doormat Size: What Size Mat for Your Door"
    },
    {
      "slug": "coir-doormat-guide",
      "title": "Coir Doormats: What Coir Is, How Long It Lasts, and How to Clean One"
    },
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    }
  ],
  "ornaments": [
    {
      "slug": "how-to-store-christmas-ornaments",
      "title": "How to Store Christmas Ornaments So They Survive Every Year"
    },
    {
      "slug": "what-is-polyresin",
      "title": "What Is Polyresin? Polyresin vs Polystone vs Ceramic for Sculptures and Decor"
    },
    {
      "slug": "christmas-tree-decorating-ideas",
      "title": "Christmas Tree Decorating Ideas: The Order That Always Works"
    }
  ],
  "christmas-trees": [
    {
      "slug": "christmas-tree-size-guide",
      "title": "What Size Christmas Tree Do I Need? Height, Width, Lights & Ornaments"
    },
    {
      "slug": "christmas-tree-decorating-ideas",
      "title": "Christmas Tree Decorating Ideas: The Order That Always Works"
    }
  ],
  "peel-and-stick-tiles": [
    {
      "slug": "peel-and-stick-backsplash-guide",
      "title": "Peel and Stick Backsplash: Are They Any Good and How to Install Them Right"
    },
    {
      "slug": "make-rental-feel-like-home",
      "title": "The Renter's Guide to a Home That Feels Permanent"
    }
  ],
  "candles": [
    {
      "slug": "soy-vs-paraffin-candles",
      "title": "Soy vs Paraffin Candles: What Candle Wax Is Made Of and How It Burns"
    },
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    }
  ],
  "lampshades": [
    {
      "slug": "lampshade-size-guide",
      "title": "Lampshade Size Guide: Measure, Fit & Style"
    },
    {
      "slug": "table-lamp-size-guide",
      "title": "Table Lamp Size Guide: How Tall & How Wide"
    }
  ],
  "pendant-lights": [
    {
      "slug": "pendant-light-height",
      "title": "Pendant Lighting Height Over a Kitchen Island (Exact Numbers)"
    },
    {
      "slug": "brass-vs-bronze",
      "title": "Brass vs Bronze: What Each Is Made Of, How to Tell Them Apart, and How to Care for Them"
    },
    {
      "slug": "dining-room-lighting-ideas",
      "title": "Dining Room Lighting Ideas: Size, Height, and Layering That Work"
    }
  ],
  "wall-lighting": [
    {
      "slug": "wall-sconce-height-guide",
      "title": "Wall Sconce Height & Placement Guide"
    },
    {
      "slug": "bathroom-vanity-lighting-guide",
      "title": "Bathroom Vanity Lights: Placement, Size, and Brightness for a Flattering Mirror"
    },
    {
      "slug": "porch-light-guide",
      "title": "Porch Lights: Size, Height, Brightness, and What Porch Light Colors Mean"
    }
  ],
  "outdoor-hanging-lights": [
    {
      "slug": "porch-light-guide",
      "title": "Porch Lights: Size, Height, Brightness, and What Porch Light Colors Mean"
    },
    {
      "slug": "layered-lighting-101",
      "title": "Layered Lighting 101: Ambient, Task, and Accent — Explained Simply"
    },
    {
      "slug": "lighting-mistakes",
      "title": "6 Lighting Mistakes That Flatten Your Room (and the Easy Fixes)"
    }
  ],
  "shower-benches": [
    {
      "slug": "teak-shower-bench-guide",
      "title": "Teak Shower Bench: Why Teak, How to Choose, and How to Care for It"
    }
  ],
  "bath-rugs": [
    {
      "slug": "how-to-wash-bath-mats",
      "title": "How to Wash Bath Mats (Cotton, Memory Foam, and Rubber-Backed)"
    }
  ],
  "compact-bedroom": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    },
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    },
    {
      "slug": "nightstand-height-guide",
      "title": "Nightstand Guide: Height, Width, and How to Pair Them"
    }
  ],
  "best-sellers": [
    {
      "slug": "first-apartment-furniture-checklist",
      "title": "Furnishing Your First Apartment: The Complete Checklist (and What to Skip)"
    },
    {
      "slug": "how-to-buy-furniture-online-with-confidence",
      "title": "How to Buy Furniture Online with Confidence"
    }
  ],
  "new-arrivals": [
    {
      "slug": "interior-design-trends-2026",
      "title": "2026 Interior and Furniture Trends Worth Following"
    }
  ]
};

export function guidesForCategory(slug: string | undefined): GuideLink[] {
  if (!slug) return [];
  return GUIDES_BY_CATEGORY[slug] ?? [];
}

/** Keyed by lower-cased Shopify productType (scripts/data/producttype-guides.json). */
export const GUIDES_BY_PRODUCT_TYPE: Record<string, GuideLink[]> = {
  "accent chairs": [
    {
      "slug": "how-to-choose-an-accent-chair",
      "title": "How to Choose an Accent Chair: Comfort, Scale, and Style"
    },
    {
      "slug": "boucle-vs-linen-vs-performance-fabric",
      "title": "Bouclé vs. Linen vs. Performance Fabric: Choosing Sofa Upholstery"
    },
    {
      "slug": "how-to-create-a-reading-nook",
      "title": "How to Create a Reading Nook (in Any Room, Any Size)"
    }
  ],
  "accent throw pillows": [
    {
      "slug": "throw-pillow-size-guide",
      "title": "Throw Pillow Sizes and Arrangement Guide"
    },
    {
      "slug": "how-to-mix-throw-pillows",
      "title": "How to Mix Throw Pillows Like a Designer (Without Overthinking It)"
    },
    {
      "slug": "add-warmth-with-textiles",
      "title": "How to Make a Room Cozy with Textiles: Layering Soft Goods"
    }
  ],
  "air mattress": [
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    }
  ],
  "artificial plants and trees": [
    {
      "slug": "biophilic-design",
      "title": "Biophilic Design: Bringing Nature Indoors"
    }
  ],
  "bar & restaurant tables": [
    {
      "slug": "bar-counter-stool-height-guide",
      "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure"
    }
  ],
  "bar carts and servers": [
    {
      "slug": "hosting-for-a-crowd",
      "title": "Hosting for a Crowd: Seating, Flow, and Flexible Furniture"
    },
    {
      "slug": "home-bar-cart-styling",
      "title": "The Home Bar Cart: How to Set Up and Style One That Works"
    }
  ],
  "bar chairs": [
    {
      "slug": "bar-counter-stool-height-guide",
      "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure"
    }
  ],
  "barware and drinkware": [
    {
      "slug": "home-bar-cart-styling",
      "title": "The Home Bar Cart: How to Set Up and Style One That Works"
    }
  ],
  "bath rugs": [
    {
      "slug": "how-to-wash-bath-mats",
      "title": "How to Wash Bath Mats (Cotton, Memory Foam, and Rubber-Backed)"
    }
  ],
  "bath towels": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    }
  ],
  "bathroom storage & organization": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    }
  ],
  "bed pillows": [
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "bed sheets": [
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "bedroom furniture sets": [
    {
      "slug": "how-to-arrange-bedroom-furniture",
      "title": "How to Arrange Bedroom Furniture: Layouts That Actually Work"
    },
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "benches": [
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    },
    {
      "slug": "dining-room-mistakes",
      "title": "Dining Room Mistakes That Make Dinners Feel Cramped (and How to Fix Them)"
    },
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    }
  ],
  "blanket racks and ladders": [
    {
      "slug": "best-bookcases-for-small-spaces",
      "title": "The Best Bookcases for Small Spaces (2026 Buyer's Guide)"
    },
    {
      "slug": "how-to-choose-a-bookcase",
      "title": "How to Choose a Bookcase or Open Shelving: Depth, Height, and Type"
    }
  ],
  "bookcases": [
    {
      "slug": "how-to-choose-a-bookcase",
      "title": "How to Choose a Bookcase or Open Shelving: Depth, Height, and Type"
    },
    {
      "slug": "best-storage-furniture-small-apartments",
      "title": "The Best Storage Furniture for Small Apartments: Our Picks"
    }
  ],
  "bowls": [
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    },
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "how-to-style-a-sideboard",
      "title": "How to Style a Sideboard or Buffet: A Simple, Layered Formula"
    }
  ],
  "bunk beds": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    }
  ],
  "cabinets": [
    {
      "slug": "best-storage-furniture-small-apartments",
      "title": "The Best Storage Furniture for Small Apartments: Our Picks"
    }
  ],
  "candle holders": [
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    }
  ],
  "candles": [
    {
      "slug": "soy-vs-paraffin-candles",
      "title": "Soy vs Paraffin Candles: What Candle Wax Is Made Of and How It Burns"
    },
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    }
  ],
  "ceiling lighting": [
    {
      "slug": "pendant-vs-flush-mount-vs-recessed-ceiling-lights",
      "title": "Pendant vs. Flush Mount vs. Recessed: Choosing Ceiling Lights"
    },
    {
      "slug": "chandelier-size-guide",
      "title": "Chandelier and Ceiling Light Size Guide: Getting Scale Right"
    }
  ],
  "chandeliers": [
    {
      "slug": "chandelier-size-guide",
      "title": "Chandelier and Ceiling Light Size Guide: Getting Scale Right"
    },
    {
      "slug": "pendant-vs-flush-mount-vs-recessed-ceiling-lights",
      "title": "Pendant vs. Flush Mount vs. Recessed: Choosing Ceiling Lights"
    },
    {
      "slug": "best-lighting-for-a-living-room",
      "title": "Living Room Lighting Ideas: How to Layer Light, Plus Our Picks"
    }
  ],
  "christmas ornaments": [
    {
      "slug": "christmas-tree-size-guide",
      "title": "What Size Christmas Tree Do I Need? Height, Width, Lights & Ornaments"
    },
    {
      "slug": "christmas-tree-decorating-ideas",
      "title": "Christmas Tree Decorating Ideas: The Order That Always Works"
    },
    {
      "slug": "how-to-store-christmas-ornaments",
      "title": "How to Store Christmas Ornaments So They Survive Every Year"
    }
  ],
  "christmas trees": [
    {
      "slug": "christmas-tree-size-guide",
      "title": "What Size Christmas Tree Do I Need? Height, Width, Lights & Ornaments"
    }
  ],
  "coat hangers": [
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    }
  ],
  "coffee tables": [
    {
      "slug": "how-to-choose-a-coffee-table",
      "title": "How to Choose a Coffee Table: Size, Shape, and Height"
    },
    {
      "slug": "small-living-room-furniture-arrangement",
      "title": "How to Arrange Furniture in a Small Living Room: Layouts That Work"
    }
  ],
  "comforters and quilts": [
    {
      "slug": "duvet-vs-comforter",
      "title": "Duvet vs Comforter: What's the Difference and Which Should You Buy?"
    },
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "console tables": [
    {
      "slug": "console-table-guide",
      "title": "Console Table Guide: Placement, Sizing, and Uses"
    },
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    },
    {
      "slug": "zone-open-plan-living-room",
      "title": "Open-Plan Living: How to Zone One Big Room"
    }
  ],
  "curtains and drapes": [
    {
      "slug": "curtain-size-guide",
      "title": "Curtain and Drapery Size Guide: Length, Width, and Hanging Height"
    },
    {
      "slug": "how-to-choose-curtains-for-modern-rooms",
      "title": "How to Choose Curtains for Modern Rooms: Fabric, Color, and Fit"
    },
    {
      "slug": "make-rental-feel-like-home",
      "title": "The Renter's Guide to a Home That Feels Permanent"
    }
  ],
  "deck boxes and outdoor/utility storage": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "desks": [
    {
      "slug": "how-to-choose-a-desk",
      "title": "How to Choose a Desk for a Home Office: Size, Depth, and Type"
    },
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    },
    {
      "slug": "first-apartment-furniture-checklist",
      "title": "Furnishing Your First Apartment: The Complete Checklist (and What to Skip)"
    }
  ],
  "dining chairs": [
    {
      "slug": "how-to-choose-dining-chairs",
      "title": "How to Choose Dining Chairs: Comfort, Height, and Material"
    }
  ],
  "dining linens": [
    {
      "slug": "how-to-set-a-table",
      "title": "How to Set a Table: Everyday to Dinner Party, Step by Step"
    }
  ],
  "dining sets": [
    {
      "slug": "dining-table-size-guide",
      "title": "Dining Table Size Guide: How Many Seats, How Much Clearance, What Fits"
    },
    {
      "slug": "breakfast-nook-ideas",
      "title": "How to Design a Breakfast Nook: Seating, Size, and Layout"
    }
  ],
  "dining tables": [
    {
      "slug": "dining-table-size-guide",
      "title": "Dining Table Size Guide: How Many Seats, How Much Clearance, What Fits"
    },
    {
      "slug": "round-vs-rectangular-dining-table",
      "title": "Round vs. Rectangular Dining Table: How to Decide"
    },
    {
      "slug": "marble-vs-quartz-vs-wood-dining-tabletops",
      "title": "Marble vs. Quartz vs. Wood Dining Tabletops: Which to Choose"
    }
  ],
  "dinnerware": [
    {
      "slug": "how-to-set-a-table",
      "title": "How to Set a Table: Everyday to Dinner Party, Step by Step"
    }
  ],
  "dog beds": [
    {
      "slug": "pet-friendly-furniture",
      "title": "Pet-Friendly Furniture and Fabrics: What Holds Up to Cats and Dogs"
    }
  ],
  "doormats": [
    {
      "slug": "doormat-size-guide",
      "title": "Standard Doormat Size: What Size Mat for Your Door"
    },
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    }
  ],
  "down comforters and duvets": [
    {
      "slug": "duvet-vs-comforter",
      "title": "Duvet vs Comforter: What's the Difference and Which Should You Buy?"
    },
    {
      "slug": "bedding-sizes-guide",
      "title": "Bedding Sizes and Layering Guide"
    }
  ],
  "dressers": [
    {
      "slug": "how-to-choose-a-dresser",
      "title": "How to Choose a Dresser or Chest of Drawers: Sizing, Types, and Fit"
    }
  ],
  "end-side tables": [
    {
      "slug": "end-table-height-guide",
      "title": "End Table Height Guide: Sizing Beside a Sofa"
    },
    {
      "slug": "how-to-choose-a-coffee-table",
      "title": "How to Choose a Coffee Table: Size, Shape, and Height"
    }
  ],
  "ergonomic accessories": [
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    },
    {
      "slug": "how-to-choose-a-desk",
      "title": "How to Choose a Desk for a Home Office: Size, Depth, and Type"
    }
  ],
  "filing cabinets": [
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    }
  ],
  "flatware": [
    {
      "slug": "how-to-set-a-table",
      "title": "How to Set a Table: Everyday to Dinner Party, Step by Step"
    }
  ],
  "floor chairs": [
    {
      "slug": "how-to-create-a-reading-nook",
      "title": "How to Create a Reading Nook (in Any Room, Any Size)"
    },
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    }
  ],
  "floor lamps": [
    {
      "slug": "floor-lamp-buying-guide",
      "title": "Floor Lamp Buying Guide: Height, Light, and Placement"
    },
    {
      "slug": "how-to-mix-metals",
      "title": "How to Mix Metals in Your Home (Brass, Black, Chrome, and More)"
    },
    {
      "slug": "best-lighting-for-a-living-room",
      "title": "Living Room Lighting Ideas: How to Layer Light, Plus Our Picks"
    }
  ],
  "foam, spring and hybrid mattresses": [
    {
      "slug": "mattress-buying-guide",
      "title": "Mattress Buying Guide: How to Choose the Right Mattress Online"
    },
    {
      "slug": "memory-foam-vs-hybrid-vs-innerspring-mattresses",
      "title": "Memory Foam vs. Hybrid vs. Innerspring Mattresses Compared"
    },
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    }
  ],
  "headboards": [
    {
      "slug": "headboard-guide",
      "title": "Headboard Guide: Styles, Heights, and Sizing by Bed Size"
    }
  ],
  "indoor planters": [
    {
      "slug": "biophilic-design",
      "title": "Biophilic Design: Bringing Nature Indoors"
    }
  ],
  "kids chairs": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    }
  ],
  "kitchen carts-islands": [
    {
      "slug": "bar-counter-stool-height-guide",
      "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure"
    },
    {
      "slug": "pendant-light-height",
      "title": "Pendant Lighting Height Over a Kitchen Island (Exact Numbers)"
    }
  ],
  "lampshades": [
    {
      "slug": "lampshade-size-guide",
      "title": "Lampshade Size Guide: Measure, Fit & Style"
    },
    {
      "slug": "table-lamp-size-guide",
      "title": "Table Lamp Size Guide: How Tall & How Wide"
    }
  ],
  "loft beds": [
    {
      "slug": "kids-room-furniture-ideas",
      "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts"
    },
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    }
  ],
  "love seats": [
    {
      "slug": "sofa-bed-vs-daybed-vs-futon",
      "title": "Sofa Bed vs. Daybed vs. Futon: Guest-Sleeping Options Compared"
    },
    {
      "slug": "sofa-buying-mistakes",
      "title": "7 Sofa-Buying Mistakes Designers See All the Time (and How to Avoid Every One)"
    },
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    }
  ],
  "luggage racks": [
    {
      "slug": "small-guest-room-ideas",
      "title": "The Small Guest Room: Comfortable on a Budget"
    }
  ],
  "mattress toppers": [
    {
      "slug": "mattress-buying-guide",
      "title": "Mattress Buying Guide: How to Choose the Right Mattress Online"
    },
    {
      "slug": "mattress-size-chart",
      "title": "Mattress Size Chart: Twin to King, Explained"
    }
  ],
  "mirrors": [
    {
      "slug": "mirror-size-guide",
      "title": "Mirror Size Guide: How Big & How High to Hang"
    },
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "nightstands & bedside tables": [
    {
      "slug": "nightstand-height-guide",
      "title": "Nightstand Guide: Height, Width, and How to Pair Them"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    },
    {
      "slug": "small-guest-room-ideas",
      "title": "The Small Guest Room: Comfortable on a Budget"
    }
  ],
  "office chairs": [
    {
      "slug": "how-to-choose-an-office-chair",
      "title": "How to Choose an Office Chair You Can Actually Sit In All Day"
    },
    {
      "slug": "functional-good-looking-home-office",
      "title": "How to Set Up a Functional, Good-Looking Home Office"
    }
  ],
  "organizers": [
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    },
    {
      "slug": "how-to-style-a-bookshelf",
      "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)"
    }
  ],
  "ottomans": [
    {
      "slug": "how-to-choose-an-ottoman",
      "title": "Ottoman Guide: Storage, Cocktail, and Accent Ottomans Compared"
    }
  ],
  "outdoor bar chairs": [
    {
      "slug": "bar-counter-stool-height-guide",
      "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure"
    },
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    }
  ],
  "outdoor benches": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "outdoor-furniture-care-guide",
      "title": "Outdoor Furniture Care: A Season-by-Season Guide"
    }
  ],
  "outdoor chairs": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "outdoor dining set": [
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    },
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    }
  ],
  "outdoor fireplaces and firepits": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "outdoor furniture - conversation sets": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "outdoor hanging lights": [
    {
      "slug": "porch-light-guide",
      "title": "Porch Lights: Size, Height, Brightness, and What Porch Light Colors Mean"
    },
    {
      "slug": "layered-lighting-101",
      "title": "Layered Lighting 101: Ambient, Task, and Accent — Explained Simply"
    },
    {
      "slug": "lighting-mistakes",
      "title": "6 Lighting Mistakes That Flatten Your Room (and the Easy Fixes)"
    }
  ],
  "outdoor ottomans": [
    {
      "slug": "how-to-choose-an-ottoman",
      "title": "Ottoman Guide: Storage, Cocktail, and Accent Ottomans Compared"
    },
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    }
  ],
  "outdoor pillows": [
    {
      "slug": "throw-pillow-size-guide",
      "title": "Throw Pillow Sizes and Arrangement Guide"
    },
    {
      "slug": "outdoor-furniture-care-guide",
      "title": "Outdoor Furniture Care: A Season-by-Season Guide"
    }
  ],
  "outdoor planters": [
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    },
    {
      "slug": "biophilic-design",
      "title": "Biophilic Design: Bringing Nature Indoors"
    }
  ],
  "outdoor rugs": [
    {
      "slug": "rug-size-guide",
      "title": "What Size Rug Do You Need? The Complete Rug Size Guide for Every Room"
    },
    {
      "slug": "are-washable-rugs-worth-it",
      "title": "Are Washable Rugs Worth It? What They're Good At, Sizes, and How to Wash Them"
    },
    {
      "slug": "outdoor-rug-size-guide",
      "title": "Outdoor Rug Size Guide: Patio & Deck Sizing"
    }
  ],
  "outdoor sectionals": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "outdoor sofas": [
    {
      "slug": "outdoor-furniture-materials",
      "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters"
    },
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "outdoor tables": [
    {
      "slug": "small-balcony-styling",
      "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room"
    },
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "outdoor umbrellas": [
    {
      "slug": "patio-layout-for-entertaining",
      "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture"
    }
  ],
  "pantry cabinets": [
    {
      "slug": "best-storage-furniture-small-apartments",
      "title": "The Best Storage Furniture for Small Apartments: Our Picks"
    }
  ],
  "peel and stick tiles": [
    {
      "slug": "peel-and-stick-backsplash-guide",
      "title": "Peel and Stick Backsplash: Are They Any Good and How to Install Them Right"
    },
    {
      "slug": "make-rental-feel-like-home",
      "title": "The Renter's Guide to a Home That Feels Permanent"
    }
  ],
  "pendants-hanging lights": [
    {
      "slug": "pendant-light-height",
      "title": "Pendant Lighting Height Over a Kitchen Island (Exact Numbers)"
    },
    {
      "slug": "pendant-vs-flush-mount-vs-recessed-ceiling-lights",
      "title": "Pendant vs. Flush Mount vs. Recessed: Choosing Ceiling Lights"
    }
  ],
  "picture frames": [
    {
      "slug": "picture-frame-sizes",
      "title": "Standard Picture Frame Sizes: A Complete Guide (in Inches)"
    },
    {
      "slug": "how-to-hang-a-picture",
      "title": "How to Hang a Picture: Height, Hardware, and Hanging Frames Without Nails"
    },
    {
      "slug": "how-to-plan-and-hang-a-gallery-wall",
      "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)"
    }
  ],
  "recliners": [
    {
      "slug": "best-accent-chairs-for-reading",
      "title": "The Best Accent Chairs for Reading: A Buyer's Guide (2026)"
    },
    {
      "slug": "faux-leather-vs-real-leather",
      "title": "Faux Leather vs Real Leather: PU, Vegan, and Bonded Leather Explained"
    }
  ],
  "rocking chairs": [
    {
      "slug": "best-accent-chairs-for-reading",
      "title": "The Best Accent Chairs for Reading: A Buyer's Guide (2026)"
    },
    {
      "slug": "nursery-furniture-guide",
      "title": "Nursery Furniture Guide: Crib, Glider, Dresser, and Storage"
    }
  ],
  "room dividers": [
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    },
    {
      "slug": "zone-open-plan-living-room",
      "title": "Open-Plan Living: How to Zone One Big Room"
    }
  ],
  "rug pads": [
    {
      "slug": "rug-care-101",
      "title": "Rug Care 101: Keeping Handwoven Rugs Looking New"
    },
    {
      "slug": "rug-size-guide",
      "title": "What Size Rug Do You Need? The Complete Rug Size Guide for Every Room"
    }
  ],
  "sculptures": [
    {
      "slug": "how-to-decorate-with-sculptures",
      "title": "How to Decorate with Sculptures: Size, Placement, and Grouping"
    },
    {
      "slug": "how-to-style-a-bookshelf",
      "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)"
    }
  ],
  "seat cushions": [
    {
      "slug": "how-to-choose-dining-chairs",
      "title": "How to Choose Dining Chairs: Comfort, Height, and Material"
    },
    {
      "slug": "breakfast-nook-ideas",
      "title": "How to Design a Breakfast Nook: Seating, Size, and Layout"
    }
  ],
  "seating sets": [
    {
      "slug": "sofa-dimensions-guide",
      "title": "Sofa Dimensions 101: How to Measure Your Space Before You Buy"
    },
    {
      "slug": "sofa-buying-mistakes",
      "title": "7 Sofa-Buying Mistakes Designers See All the Time (and How to Avoid Every One)"
    }
  ],
  "sectionals": [
    {
      "slug": "modular-vs-fixed-sectional",
      "title": "Modular vs. Fixed Sectionals: Flexibility or Stability?"
    },
    {
      "slug": "best-sectionals-for-small-spaces",
      "title": "The Best Sectionals for Small Spaces: Our Picks"
    },
    {
      "slug": "sectional-vs-sofa",
      "title": "Sectional vs. Sofa: Which Is Right for Your Space?"
    }
  ],
  "serving bowls": [
    {
      "slug": "dining-room-styling",
      "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes"
    },
    {
      "slug": "hosting-for-a-crowd",
      "title": "Hosting for a Crowd: Seating, Flow, and Flexible Furniture"
    }
  ],
  "shoe racks": [
    {
      "slug": "mudroom-drop-zone-ideas",
      "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use"
    },
    {
      "slug": "entryway-styling-console-mirror-landing-zone",
      "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works"
    }
  ],
  "shower benches": [
    {
      "slug": "teak-shower-bench-guide",
      "title": "Teak Shower Bench: Why Teak, How to Choose, and How to Care for It"
    }
  ],
  "sideboards": [
    {
      "slug": "how-to-style-a-sideboard",
      "title": "How to Style a Sideboard or Buffet: A Simple, Layered Formula"
    }
  ],
  "sofas": [
    {
      "slug": "sofa-dimensions-guide",
      "title": "Sofa Dimensions 101: How to Measure Your Space Before You Buy"
    },
    {
      "slug": "sectional-vs-sofa",
      "title": "Sectional vs. Sofa: Which Is Right for Your Space?"
    },
    {
      "slug": "leather-vs-fabric-sofa",
      "title": "Leather vs. Fabric Sofas: Pros, Cons, and Real-Life Durability"
    }
  ],
  "standard beds": [
    {
      "slug": "how-to-choose-a-bed-frame",
      "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip"
    },
    {
      "slug": "upholstered-vs-wood-vs-metal-bed-frames",
      "title": "Upholstered vs. Wood vs. Metal Bed Frames: Material Comparison"
    },
    {
      "slug": "platform-bed-vs-box-spring",
      "title": "Platform Bed vs. Box Spring: What Modern Bedrooms Actually Need"
    }
  ],
  "tv stands": [
    {
      "slug": "how-to-choose-a-tv-stand",
      "title": "How to Choose a Media Console (TV Stand): Size, Height, and Cables"
    },
    {
      "slug": "tv-size-for-room",
      "title": "What Size TV for Your Room? Viewing Distance Explained"
    }
  ],
  "table lamps": [
    {
      "slug": "table-lamp-size-guide",
      "title": "Table Lamp Size Guide: How Tall & How Wide"
    },
    {
      "slug": "best-lighting-for-a-living-room",
      "title": "Living Room Lighting Ideas: How to Layer Light, Plus Our Picks"
    },
    {
      "slug": "lighting-mistakes",
      "title": "6 Lighting Mistakes That Flatten Your Room (and the Easy Fixes)"
    }
  ],
  "throws & blankets": [
    {
      "slug": "throw-blanket-size-guide",
      "title": "Throw Blanket Size Guide: Sofa, Bed & Chair"
    },
    {
      "slug": "how-to-create-a-reading-nook",
      "title": "How to Create a Reading Nook (in Any Room, Any Size)"
    },
    {
      "slug": "add-warmth-with-textiles",
      "title": "How to Make a Room Cozy with Textiles: Layering Soft Goods"
    }
  ],
  "trays": [
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "home-bar-cart-styling",
      "title": "The Home Bar Cart: How to Set Up and Style One That Works"
    }
  ],
  "umbrella stands & bases": [
    {
      "slug": "outdoor-dining-setup",
      "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work"
    }
  ],
  "vases": [
    {
      "slug": "vase-size-guide",
      "title": "Vase Size Guide: Height, Shape & Placement"
    },
    {
      "slug": "how-to-style-a-coffee-table",
      "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method"
    },
    {
      "slug": "how-to-style-a-bookshelf",
      "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)"
    }
  ],
  "wall art": [
    {
      "slug": "wall-art-size-guide",
      "title": "Wall Art Size Guide: Over a Sofa, Bed & More"
    },
    {
      "slug": "how-to-plan-and-hang-a-gallery-wall",
      "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)"
    },
    {
      "slug": "living-room-feels-unfinished",
      "title": "Why Your Living Room Feels Unfinished — and the 5 Fixes That Work"
    }
  ],
  "wall decor": [
    {
      "slug": "wall-art-size-guide",
      "title": "Wall Art Size Guide: Over a Sofa, Bed & More"
    },
    {
      "slug": "how-to-plan-and-hang-a-gallery-wall",
      "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)"
    }
  ],
  "wall lighting": [
    {
      "slug": "wall-sconce-height-guide",
      "title": "Wall Sconce Height & Placement Guide"
    },
    {
      "slug": "lighting-mistakes",
      "title": "6 Lighting Mistakes That Flatten Your Room (and the Easy Fixes)"
    },
    {
      "slug": "layered-lighting-101",
      "title": "Layered Lighting 101: Ambient, Task, and Accent — Explained Simply"
    }
  ],
  "wall mounted shelves": [
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    },
    {
      "slug": "how-to-furnish-a-studio-apartment",
      "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces"
    },
    {
      "slug": "small-bedroom-ideas",
      "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works"
    }
  ],
  "wall clocks": [
    {
      "slug": "wall-clock-size-guide",
      "title": "What Size Wall Clock? Size and Hanging Height by Room"
    },
    {
      "slug": "wall-art-size-guide",
      "title": "Wall Art Size Guide: Over a Sofa, Bed & More"
    }
  ],
  "bathroom vanities": [
    {
      "slug": "bathroom-vanity-size-guide",
      "title": "What Size Bathroom Vanity? Width, Height, Depth and Clearances"
    },
    {
      "slug": "small-bathroom-storage-ideas",
      "title": "Small Bathroom Storage Ideas That Make Every Inch Work"
    }
  ]
};

export function guidesForProductType(productType: string | undefined): GuideLink[] {
  if (!productType) return [];
  return GUIDES_BY_PRODUCT_TYPE[productType.trim().toLowerCase()] ?? [];
}
